import { render, staticRenderFns } from "./MetricChart.vue?vue&type=template&id=6f001170&scoped=true"
import script from "./MetricChart.vue?vue&type=script&lang=js"
export * from "./MetricChart.vue?vue&type=script&lang=js"
import style0 from "./MetricChart.vue?vue&type=style&index=0&id=6f001170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f001170",
  null
  
)

export default component.exports